import { createContext } from '@wordpress/element';
export const slotNameContext = createContext(undefined);
slotNameContext.displayName = '__unstableSlotNameContext';